export enum AssetStatusEnum {
  ActNow = 1,
  Act = 2,
  Plan = 3
}
